import equipData from "@project/data/rogue_4/game/equip.json"

import { loadImage } from "@/utils/misc"
import { GAME_EQUIP_DICT } from "../data/battle"
import { drawQRCode } from "./qrCode"

import Health2 from "../../../assets/img/game/boss/health-kalts.png"
import Health1 from "../../../assets/img/game/boss/health-nymph.png"
import crownie from "../../../assets/img/game/character/crownie/full.png"
import ermengarde from "../../../assets/img/game/character/ermengarde/full.png"
import hraaselsuher from "../../../assets/img/game/character/hraaselsuher/full.png"
import kalts from "../../../assets/img/game/character/kalts/full.png"
import mitm from "../../../assets/img/game/character/mitm/full.png"
import nymph from "../../../assets/img/game/character/nymph/full.png"
import qalaisa from "../../../assets/img/game/character/qalaisa/full.png"
import tinman from "../../../assets/img/game/character/tinman/full.png"
import IconAttack from "../../../assets/img/game/icon/attack.png"
import IconBuff from "../../../assets/img/game/icon/buff.png"
import IconDebuff from "../../../assets/img/game/icon/debuff.png"
import IconDefault from "../../../assets/img/game/icon/default-equip-big.png"
import IconGuard from "../../../assets/img/game/icon/guard.png"
import IconHealth from "../../../assets/img/game/icon/health.png"
import ItemLabel from "../../../assets/img/game/modal/item-label.png"
import Label from "../../../assets/img/game/share/label.png"
import CraftMask from "../../../assets/img/game/share/mask.png"
import ShareBg from "../../../assets/img/game/share/share-bg.png"

export const downloadImage = async (name: string, src: string) => {
    const a = document.createElement("a")
    a.download = `${name}.png`
    a.href = src
    a.click()
}

export const getBase64Image = async (src: string) => {
    const img = new Image()
    img.src = src

    await new Promise((resolve) => {
        img.onload = resolve
    })

    const canvas = document.createElement("canvas")
    canvas.width = img.width
    canvas.height = img.height

    const ctx = canvas.getContext("2d")
    ctx?.drawImage(img, 0, 0, img.width, img.height)

    return {
        img,
        base64: canvas.toDataURL("image/png"),
    }
}

const chars = {
    crownie,
    ermengarde,
    hraaselsuher,
    kalts,
    mitm,
    nymph,
    qalaisa,
    tinman,
}

const clipImageWidth = (image: HTMLImageElement, percent: number) => {
    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")
    if (!ctx) {
        throw new Error("Failed to get canvas context")
    }

    canvas.width = image.width * percent
    canvas.height = image.height

    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(image, 0, 0)

    return canvas
}

const getMaskCraftImage = async (id: string) => {
    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")
    if (!ctx) {
        throw new Error("Failed to get canvas context")
    }

    const craftImage = await loadImage(GAME_EQUIP_DICT[id].image)
    const mask = await loadImage(CraftMask)

    canvas.width = mask.width
    canvas.height = mask.height

    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(mask, 0, 0)
    ctx.globalCompositeOperation = "source-in"
    ctx.drawImage(craftImage, 0, 0, mask.width, mask.height)

    return canvas
}

export const drawShareImage = async (
    uid: string,
    nickname: string,
    char: string,
    hp1: number,
    hp2: number,
    desc: string,
    equipments: string[]
) => {
    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")
    if (!ctx) {
        throw new Error("Failed to get canvas context")
    }

    // bg
    const bg = await loadImage(ShareBg)
    canvas.width = bg.naturalWidth
    canvas.height = bg.naturalHeight
    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(bg, 0, 0)

    // char
    const charImage = await loadImage(chars[char])
    if (char === "mitm") {
        ctx.drawImage(
            charImage,
            480 - charImage.naturalWidth / 2,
            canvas.height + 40 - charImage.naturalHeight,
            745 * 0.875,
            834 * 0.875
        )
    } else if (char === "crownie") {
        ctx.drawImage(
            charImage,
            460 - charImage.naturalWidth / 2,
            canvas.height + 40 - charImage.naturalHeight,
            801 * 0.875,
            926 * 0.875
        )
    } else if (char === "qalaisa") {
        ctx.drawImage(
            charImage,
            460 - charImage.naturalWidth / 2,
            canvas.height - charImage.naturalHeight,
            706 * 0.875,
            861 * 0.875
        )
    } else if (char === "tinman") {
        ctx.drawImage(
            charImage,
            480 - charImage.naturalWidth / 2,
            canvas.height - charImage.naturalHeight,
            820 * 0.875,
            827 * 0.875
        )
    } else if (char === "hraaselsuher") {
        ctx.drawImage(
            charImage,
            450 - charImage.naturalWidth / 2,
            canvas.height - 90 - charImage.naturalHeight,
            554 * 0.875,
            707 * 0.875
        )
    } else if (char === "kalts") {
        ctx.drawImage(
            charImage,
            465- charImage.naturalWidth / 2,
            canvas.height - 40 - charImage.naturalHeight,
            896 * 0.9,
            805 * 0.9
        )
    } else {
        ctx.drawImage(
            charImage,
            480 - charImage.naturalWidth / 2,
            canvas.height - 140 - charImage.naturalHeight
        )
    }

    // name
    const label = await loadImage(Label)
    ctx.drawImage(label, 10, 798)
    ctx.font = "bold 40px PingFangSC, sans-serif"
    ctx.fillStyle = "#f0eedd"
    ctx.textAlign = "center"
    const name = `Dr.${nickname.split("#")?.[0]}`
    ctx.fillText(name, 10 + label.naturalWidth / 2, 858)

    // hp
    if (hp1 > 0) {
        const hp1Image = await loadImage(Health1)
        const clippedHp1 = clipImageWidth(hp1Image, hp1 / 10)
        ctx.drawImage(
            clippedHp1,
            767,
            canvas.height - 253 - hp1Image.naturalHeight
        )
    }
    if (hp2 > 0) {
        const hp2Image = await loadImage(Health2)
        const clippedHp2 = clipImageWidth(hp2Image, hp2 / 10)
        ctx.drawImage(
            clippedHp2,
             769 + 375,
            canvas.height - 253 - hp2Image.naturalHeight
        )
    }

    // desc
    ctx.font = "normal 34px SourceHanSans-Medium"
    ctx.fillStyle = "#f4ede3"
    ctx.textAlign = "left"
    const lines = desc.split("\n")
    for (let i = 0; i < lines.length; i++) {
        ctx.fillText(lines[i], 765, 890 + i * 50)
    }

    // equip
    const itemLabel = await loadImage(ItemLabel)
    const itemLabelX = [
        766,
        840 + itemLabel.naturalWidth + 15,
        915 + itemLabel.naturalWidth * 2 + 28,
    ]
    const craftImageX = [
        802 + 24,
        865 + itemLabel.naturalWidth + 36,
        955 + itemLabel.naturalWidth * 2 + 44,
    ]
    const itemNameY = 618 + 27
    ctx.font = "normal 16px SourceHanSans-Bold"
    ctx.fillStyle = "#57453c"
    ctx.textAlign = "center"
    for (let i = 0; i < equipments.length; i++) {
        const craftImage = await getMaskCraftImage(equipments[i])
        ctx.drawImage(
            craftImage,
            craftImageX[i],
            419,
            craftImage.width * 0.96,
            craftImage.height * 0.96
        )

        ctx.drawImage(itemLabel, itemLabelX[i]-10, 618)

        const equip = equipData[equipments[i]]
        ctx.fillText(
            equip.name,
            itemLabelX[i]-10 + itemLabel.naturalWidth / 2,
            itemNameY
        )

        let icon: HTMLImageElement | null = null
        if (equip.type === "attack") {
            icon = await loadImage(IconAttack)
        } else if (equip.type === "guard") {
            icon = await loadImage(IconGuard)
        } else if (equip.type === "health") {
            icon = await loadImage(IconHealth)
        } else if (equip.type === "buff") {
            icon = await loadImage(IconBuff)
        } else if (equip.type === "debuff") {
            icon = await loadImage(IconDebuff)
        } else {
            icon = await loadImage(IconDefault)
        }
        if (icon) {
            ctx.drawImage(icon, itemLabelX[i] , 432, 80, 80)
        }
    }

    // 二维码
    const qrCodeSrc = await drawQRCode({ uid, size: 169 / 16 })
    const qrCode = await loadImage(qrCodeSrc)
    ctx.drawImage(qrCode, canvas.width - 221, canvas.height - 218)

    return new Promise<string>((resolve) => {
        canvas.toBlob((blob) => {
            if (blob) {
                const url = URL.createObjectURL(blob)
                resolve(url)
            }

            resolve("")
        })
    })
}
